export default {"src":"/_next/static/media/profile-pro.74faf95c.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};